import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Store,
  Bike,
  Users,
  ClipboardList,
  FileCheck,
  Percent,
  Send,
  MapPin,
  Wallet,
  Brush,
  Palette,
  ShieldCheck,
  Settings
} from 'lucide-react';

const links = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/lojas', label: 'Lojas', icon: Store },
  { to: '/admin/motoboys', label: 'Motoboys', icon: Bike },
  { to: '/admin/clientes', label: 'Clientes', icon: Users },
  { to: '/admin/pedidos', label: 'Pedidos', icon: ClipboardList },
  { to: '/admin/avaliacoes-validacoes', label: 'Avaliacoes', icon: FileCheck },
  { to: '/admin/taxas-regras', label: 'Taxas e Regras', icon: Percent },
  { to: '/admin/taxas-regras?section=envios-viagens', label: 'Envios e Viagens', icon: Send },
  { to: '/admin/raio', label: 'Raio', icon: MapPin },
  { to: '/admin/financeiro', label: 'Financeiro', icon: Wallet },
  { to: '/admin/conteudo-aparencia', label: 'Conteudo', icon: Brush },
  { to: '/admin/aparencia-admin', label: 'Aparencia Admin', icon: Palette },
  { to: '/admin/auditoria', label: 'Auditoria', icon: ShieldCheck },
  { to: '/admin/configuracoes', label: 'Configuracoes', icon: Settings }
];

export default function AdminSidebar() {
  return (
    <aside className="admin-sidebar">
      <div className="admin-brand">
        <span className="admin-brand-mark" aria-hidden="true">CF</span>
        <h1>Correfood Admin</h1>
        <span>Controle total do sistema</span>
      </div>

      <nav className="admin-nav">
        {links.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} className={({ isActive }) => (isActive ? 'active' : '')}>
            <Icon size={16} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="admin-sidebar-footer">
        Ambiente Seguro - Somente Admin
      </div>
    </aside>
  );
}
